import React, { useContext, useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PresentPC from 'components/pages/AddConf/PresentPC';
import PresentSP from 'components/pages/AddConf/PresentSP';
import AppContext from 'fluxes/context';

import PcErrorArea from 'components/molecules/PcErrorArea';
import TextInput from 'components/atoms/Input/TextInput';
import RadioInput from 'components/atoms/Input/RadioInput';
import DropdownInput from 'components/atoms/Input/DropdownInput';

import {
  CHANGE_VALID,
  UPDATE_ADD_CONF,
  RESET_ADD_CONF,
} from 'fluxes/actions';

import { postRegisterOrderApi } from 'utils/api';

import {
  ADD_INPUT_URL,
  ADD_THANKS_URL,
  CHOICES_MAP,
  ADD_CONF_OD_TITLE_TEXT,
  ADD_INPUT_CONF_TITLE,
  MEASURE_MAP,
  COMMENT_MAP,
} from 'utils/constant';

import {
  useDirectTransCheck,
  useWindowDimensions,
  useIECheck,
  isSchemaValid,
  isCustomValid,
  isFatalApiError,
  sortErrors,
  getChoiceLabel,
  getChoiceValues,
  changeStr,
  scrollTop,
} from 'utils';
import MeasureEvent from 'utils/measureEvent';

const AddConf = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  const [ isApiError, setIsApiError ] = useState(false);
  const [ showLoading, setShowLoding ] = useState(false);

  const history = useHistory();

  const [ isOpenDesiredStartTime, setIsOpenDesiredStartTime ] = useState(false);
  const [ isOpenWorkPeriod, setIsOpenWorkPeriod ] = useState(false);
  const [ isOpenWorkDay, setIsOpenWorkDay ] = useState(false);

  const [ isOpenWorkTime, setIsOpenWorkTime ] = useState(false);
  const [ isOpenOverTime, setIsOpenOverTime ] = useState(false);
  const [ isOpenSalary, setIsOpenSalary ] = useState(false);
  const [ isOpenSkillExcel, setIsOpenSkillExcel ] = useState(false);
  const [ isOpenSkillPowerpoint, setIsOpenSkillPowerpoint ] = useState(false);

  const [ strWorkInfo, setStrWorkInfo ] = useState(state.strWorkInfo);
  const [ isOpenWorkInfo, setIsOpenWorkInfo ] = useState(false);

  const [ strWorkPeriod, setStrWorkPeriod ] = useState('');
  const [ workInfoContentCmnt, setWorkInfoContentCmnt ] = useState(state.workInfoContentCmnt);
  const [ strOtherSkill, setStrOtherSkill ] = useState(state.skillOtherCmnt);
  const [ strWorkTime, setStrWorkTime ] = useState('');
  const [ startTimeCmnt, setStartTimeCmnt ] = useState(state.startTimeCmnt);
  const [ endTimeCmnt, setEndTimeCmnt ] = useState(state.endTimeCmnt);
  
  const [ strWorkEnvi, setStrWorkEnvi ] = useState(state.strWorkEnvi);
  const [ isOpenWorkEnvi, setIsOpenWorkEnvi ] = useState(false);
  const [ isOpenOtherSkill, setIsOpenOtherSkill ] = useState(false);

  const [ isOpenBgdOfRecruitment, setIsOpenBgdOfRecruitment ] = useState(false);

  const [ isOpenRemoteWork, setIsOpenRemoteWork ] = useState(false);
  const [ isOpenHolidayWork, setIsOpenHolidayWork ] = useState(false);
  const [ isOpenTimeSavingAva, setIsOpenTimeSavingAva ] = useState(false);
  const [ isOpenUseCar, setIsOpenUseCar ] = useState(false);
  const [ isOpenSmokeEnvi, setIsOpenSmokeEnvi ] = useState(false);
  const [ isOpenWelfare, setIsOpenWelfare ] = useState(false);

  const [ isOpenConfirm, setIsOpenConfirm ] = useState(false);

  const [ desiredStartDateKubun, setDesiredStartDateKubun ] = useState(state.desiredStartDateKubun);
  const [ desiredStartDate, setDesiredStartDate ] = useState(state.desiredStartDate);
  const [ workPeriod, setWorkPeriod ] = useState(state.workPeriod);
  const [ workPeriodCmnt, setWorkPeriodCmnt ] = useState(state.workPeriodCmnt);

  const [ strDayOfTheWeek, setStrDayOfTheWeek ] = useState('');
  const [ workStyleCmnt, setWorkStyleCmnt ] = useState(state.workStyleCmnt);

  const [ overTime, setOverTime ] = useState(state.overTime);
  const [ overtimeHoursMin, setOvertimeHoursMin ] = useState(state.overtimeHoursMin);
  const [ overtimeHoursMax, setOvertimeHoursMax ] = useState(state.overtimeHoursMax);

  const [ hourSalaryMin, setHourSalaryMin ] = useState(state.hourSalaryMin);
  const [ hourSalaryMax, setHourSalaryMax ] = useState(state.hourSalaryMax);

  const [ timeSavingAva, setTimeSavingAva ] = useState(state.timeSavingAva);

  const [ skillLevelExcel, setSkillLevelExcel ] = useState(state.skillLevelExcel);
  const [ skillLevelPowerpoint, setSkillLevelPowerpoint ] = useState(state.skillLevelPowerpoint);

  const [ bgdOfRecruitment, setBgdOfRecruitment ] = useState(state.bgdOfRecruitment);
  const [ bgdOfRecruitmentCmnt, setBgdOfRecruitmentCmnt ] = useState(state.bgdOfRecruitmentCmnt);

  const [ remoteWork, setRemoteWork ] = useState(state.remoteWork);
  const [ remoteWorkCount, setRemoteWorkCount ] = useState(state.remoteWorkCount);
  const [ holidayWork, setHolidayWork ] = useState(state.holidayWork);
  const [ useCar, setUseCar ] = useState(state.useCar);
  const [ smokeEnvi, setSmokeEnvi ] = useState(state.smokeEnvi);
  const [ welfare, setWelfare ] = useState(state.welfare);

  const [ otherComment, setOtherComment ] = useState(state.OtherComment);

  // モーダル選択state
  const [ _selectDate, setSelectDate ] = useState();
  const [ _selectDateKubun, setSelectDateKubun ] = useState();

  const [ _selectWorkPeriod, setSelectWorkPeriod ] = useState('');
  const [ _selectDayOfTheWeek, setSelectDayOfTheWeek ] = useState('');

  const [ _modalWorkTime, setModalWorkTime ] = useState('');

  const [ _selectOverTimeMin, setSelectOverTimeMin ] = useState('');
  const [ _selectOverTimeMax, setSelectOverTimeMax ] = useState('');

  const [ _modalSalaryMin, setModalSalaryMin ] = useState('');
  const [ _modalSalaryMax, setModalSalaryMax ] = useState('');

  const [ _selectExcel, setSelectExcel ] = useState();
  const [ _selectPowerpoint, setSelectPowerpoint ] = useState();

  const [ _modalWorkInfo, setModalWorkInfo ] = useState('');
  const [ _modalWorkEnvi, setModalWorkEnvi ] = useState('');
  const [ _modalOtherSkill, setMdalOtherSkill ] = useState('');
  const [ _selectBgdOfRecruitment, setSelectBgdOfRecruitment ] = useState();
  const [ _selectBgdOfRecruitmentCmnt, setSelectBgdOfRecruitmentCmnt ] = useState('');

  const [ _selectRemoteWork, setSelectRemoteWork ] = useState('');
  const [ _selectRemoteWorkCount, setSelectRemoteWorkCount ] = useState('');
  const [ _selectHolidayWork, setSelectHolidayWork ] = useState('');
  const [ _selectTimeSavingAva, setSelectTimeSavingAva ] = useState('');
  const [ _selectUseCar, setSelectUseCar ] = useState('');
  const [ _selectSmokeEnvi, setSelectSmokeEnvi ] = useState('');
  const [ _selectWelfare, setSelectWelfare ] = useState([]);

  const [ workInfoContent, setWorkInfoContent ] = useState(state.workInfoContent);

  const { 
    startTime,
    endTime,
    skillLevel,
    workStyle,
    workEnvi,
    companyNameText,
    email,
    receiptID,
    isAddRegistered, 
    olodTarget,
    clickID,
    mediaID,
  } = state;

  const NOT_FILL = <label className='ACONF_nofFill'>未入力</label>;

  // CHOICES_MAPリスト
  const {
    skillLevelExcelConfList,
    skillLevelPowerpointConfList,
    overTimeHourList,
    desiredStartDateKubunList,
    bgdOfRecruitmentList,
    useCarList,
    holidayWorkList,
    remoteWorkList,
    remoteWorkCountList,
    welfareList,
    smokeEnviList,
    timeSavingAvaList
  } = CHOICES_MAP;

  // 直接遷移チェック
  useDirectTransCheck({ state });
  
  // ブラウザバックを禁止する
  const blockBrowserBack = useCallback(() => {
    window.history.go(1)
  }, [])

  useEffect(() => {
    // 直前の履歴に現在のページを追加
    window.history.pushState(null, null, window.location.href)

    // 直前の履歴と現在のページのループ
    window.addEventListener('popstate', blockBrowserBack)

    // クリーンアップ
    return () => {
      window.removeEventListener('popstate', blockBrowserBack)
    }
  }, [blockBrowserBack])


  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // 入力チェック用変数
  const initialValid = { valid: state.validMap[path], errorMessages: [] };
  const [ valids, setValids ] = useState({
    schema: initialValid,
  });
  const [ overTimeValids, setOverTimeValids ] = useState({
    checkOverTimeLessThan0Hour: initialValid,
  });
  const [ hourSalaryValids, setHourSalaryValids ] = useState({
    hourSalarySchema: initialValid,
    checkHourSalaryLessThanZero: initialValid,
  });
  const [ workInfoValids, setWorkInfoValids ] = useState({
    workInfoSchema: initialValid,
  });
  const [ workPeriodValids, setWorkPeriodValids ] = useState({
    workPeriodSchema: initialValid,
  });
  const [ dayOfTheWeekValids, setDayOfTheWeekValids ] = useState({
    dayOfTheWeekSchema: initialValid,
  });
  const [ workTimeValids, setWorkTimeValids ] = useState({
    workTimeSchema: initialValid,
  });
  const [ workEnviValids, setWorkEnviValids ] = useState({
    workEnviSchema: initialValid,
  });
  const [ bgdOfRecruitmentCmntValids, setBgdOfRecruitmentCmntValids ] = useState({
    bgdOfRecruitmentCmntSchema: initialValid,
  });
  const [ otherSkillValids, setOtherSkillValids ] = useState({
    otherSkillSchema: initialValid,
  });
  const [ welfareValids, setWelfareValids ] = useState({ welfareSchema: initialValid, });
  const [ remoteWorkValids, setRemoteWorkValids ] = useState({ remoteWorkSchema: initialValid, });

  // 初期入力チェック設定
  const [ isShowError, setIsShowError ] = useState({
    workTime: true,
    overTime: true,
    hourSalary: true,
    otherComment: false,
    _modalWorkInfo: false,
    _modalWorkEnvi: false,
    _modalWorkTime: false,
    _modalOtherSkill: false,
    _selectWorkPeriod: false,
    _selectDayOfTheWeek: false,
    _modalSalaryMin: false,
    _selectBgdOfRecruitmentCmnt: false,
    _selectWelfare: false,
    remoteWorkCount: false
  });
  // エラーの画面表示で利用する値
  const valid = Object.keys(valids).every(key => valids[key].valid); 
  const dispErrors = useCallback(() => {
    const { schema } = valids;
    const { checkOverTimeLessThan0Hour } = overTimeValids;
    const { hourSalarySchema, checkHourSalaryLessThanZero } = hourSalaryValids;
    const { workInfoSchema } = workInfoValids;
    const { workPeriodSchema } = workPeriodValids;
    const { dayOfTheWeekSchema } = dayOfTheWeekValids;
    const { workEnviSchema } = workEnviValids;
    const { bgdOfRecruitmentCmntSchema } = bgdOfRecruitmentCmntValids;
    const { workTimeSchema } = workTimeValids;
    const { otherSkillSchema } = otherSkillValids;
    const { welfareSchema } = welfareValids;
    const { remoteWorkSchema } = remoteWorkValids;
    const errors = sortErrors([
      ...schema.errorMessages,
      ...checkOverTimeLessThan0Hour.errorMessages,
      ...hourSalarySchema.errorMessages,
      ...checkHourSalaryLessThanZero.errorMessages,
      ...workInfoSchema.errorMessages,
      ...workPeriodSchema.errorMessages,
      ...workEnviSchema.errorMessages,
      ...bgdOfRecruitmentCmntSchema.errorMessages,
      ...dayOfTheWeekSchema.errorMessages,
      ...otherSkillSchema.errorMessages,
      ...workTimeSchema.errorMessages,
      ...welfareSchema.errorMessages,
      ...remoteWorkSchema.errorMessages,
    ]);
    const errorMap = errors.reduce((obj, error) => {
      const { target, message } = error;
      if(!isShowError[target] || Object.keys(obj).includes(target)) return obj;
      return { ...obj, [target]: message };
    }, {});
    return errorMap;
  }, [ isShowError, valids, overTimeValids, hourSalaryValids, workInfoValids, workPeriodValids, workEnviValids, bgdOfRecruitmentCmntValids, otherSkillValids, dayOfTheWeekValids, workTimeValids, welfareValids, remoteWorkValids]);

  // 入力チェック（全体）
  useEffect(()=> {
    // エラーチェックを実行
    let [ isValid, newErrorMessages ] = isSchemaValid({
      target: {
        otherComment,
      },
    });

    // erros更新
    const newValid = { schema: { valid: isValid, errorMessages: newErrorMessages } };
    setValids(org => ({ ...org, ...newValid }));
  }, [ otherComment ]);
  
  // 請求金額 モーダル内入力チェック
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-HourSalary`, 
      target: {
        _modalSalaryMin,
        _modalSalaryMax,
      },
    });
    // erros更新
    const newValid = { hourSalarySchema: { valid: isValid, errorMessages: newErrorMessages } };
    setHourSalaryValids(org => ({ ...org, ...newValid }));
  }, [ _modalSalaryMin, _modalSalaryMax, path ]);

  //  就業予定期間 モーダル内入力チェック
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-workPeriod`, 
      target: {
        _selectWorkPeriod,
      },
    });
    // erros更新
    const newValid = { workPeriodSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWorkPeriodValids(org => ({ ...org, ...newValid }));
  }, [ _selectWorkPeriod, path ]);

  //  勤務日 モーダル内入力チェック
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-dayOfTheWeek`, 
      target: {
        _selectDayOfTheWeek,
      },
    });
    // erros更新
    const newValid = { dayOfTheWeekSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setDayOfTheWeekValids(org => ({ ...org, ...newValid }));
  }, [ _selectDayOfTheWeek, path ]);

  // 仕事内容 モーダル内入力チェック
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-workInfo`, 
      target: {
        _modalWorkInfo,
      },
    });
    // erros更新
    const newValid = { workInfoSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWorkInfoValids(org => ({ ...org, ...newValid }));
  }, [ _modalWorkInfo, path ]);

  // その他スキル モーダル内入力チェック
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-otherSkill`, 
      target: {
        _modalOtherSkill,
      },
    });
    // erros更新
    const newValid = { otherSkillSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setOtherSkillValids(org => ({ ...org, ...newValid }));
  }, [ _modalOtherSkill, path ]);


  // 勤務時間 モーダル内入力チェック
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-workTime`, 
      target: {
        _modalWorkTime,
      },
    });
    // erros更新
    const newValid = { workTimeSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWorkTimeValids(org => ({ ...org, ...newValid }));
  }, [ _modalWorkTime, path ]);

  // 職場環境 モーダル内入力チェック
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-workEnvi`, 
      target: {
        _modalWorkEnvi,
      },
    });
    // erros更新
    const newValid = { workEnviSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWorkEnviValids(org => ({ ...org, ...newValid }));
  }, [ _modalWorkEnvi, path ]);
  
  // 福利厚生 モーダル内入力チェック
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-welfare`,
      target: {
        _selectWelfare,
      },
    });
    // erros更新
    const newValid = { welfareSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWelfareValids(org => ({ ...org, ...newValid }));
  }, [_selectWelfare, path]);

  // テレワーク モーダル内入力チェック
  useEffect(() => {
    // エラーチェックを実行.
    const remoteWorkValidation = async () => {
      // エラーチェックを実行
      const [isValid, newErrorMessages] = await isCustomValid({
        checks: ['checkRemoteWorkCount'],
        target: {
          remoteWork: _selectRemoteWork,
          remoteWorkCount: _selectRemoteWorkCount
        },
      });

      // erros更新
      const newValid = { remoteWorkSchema: { valid: isValid, errorMessages: newErrorMessages } };
      setRemoteWorkValids(org => ({ ...org, ...newValid }));
    };
    remoteWorkValidation();
  }, [_selectRemoteWork, _selectRemoteWorkCount]);

  // 相関チェック
  // 最大残業時間 - 最小残業時間 < 0
  useEffect(() => {
    const overTimeValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThanZero' ],
        target: { target: 'overTime', min: _selectOverTimeMin, max: _selectOverTimeMax },
      });

      // erros更新
      const newValid = { checkOverTimeLessThan0Hour: { valid: isValid, errorMessages: newErrorMessages } };
      setOverTimeValids(org => ({ ...org, ...newValid }));
    };
    overTimeValidation();
  }, [ _selectOverTimeMin, _selectOverTimeMax ]);

  // 最大請求金額 - 最小請求金額 < 0
  useEffect(() => {
    const hourSalaryValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThanZero' ],
        target: { target: '_modalSalaryMin', min: _modalSalaryMin, max: _modalSalaryMax },
      });
      // erros更新
      const newValid = { checkHourSalaryLessThanZero: { valid: isValid, errorMessages: newErrorMessages } };
      setHourSalaryValids(org => ({ ...org, ...newValid }));
    };
    hourSalaryValidation();
  }, [ _modalSalaryMin, _modalSalaryMax ]);

  // 募集背景モーダル内フリーワード入力チェック
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-bgdOfRecruitmentCmnt`,
      target: {
        _selectBgdOfRecruitment,
        _selectBgdOfRecruitmentCmnt,
      },
    });
    // erros更新
    const newValid = { bgdOfRecruitmentCmntSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setBgdOfRecruitmentCmntValids(org => ({ ...org, ...newValid }));
  }, [ _selectBgdOfRecruitment, _selectBgdOfRecruitmentCmnt, path]);

  // モーダル
  /** * 就業開始時期 モーダル START *** */
  const changeDesiredStartTime = ()=>{
    setSelectDate(desiredStartDate);
    setSelectDateKubun(desiredStartDateKubun);
    setIsOpenDesiredStartTime(true);
  };
  const isCloseDesiredStartTime = () => {
    setIsOpenDesiredStartTime(false);
  };
  const isSaveDesiredStartTime = () => {
    setDesiredStartDate(_selectDate);
    setDesiredStartDateKubun(_selectDateKubun);
    setIsOpenDesiredStartTime(false);
  };
  // 就業開始時期 選択
  const onChangeDesireStartDate = (e)=>{
    if (e.target.value === '01') {
      setSelectDate();
      setSelectDateKubun(e.target.value);
    }
  };
  // 日付選択時イベント
  const handleChangeDate = (e, val) => {
    const date = new Date(
      `${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(6)}`,
    );
    setSelectDate(changeStr(date));
    setSelectDateKubun(val);
  };

  // モーダル中身
  const desiredStartDateData = desiredStartDateKubunList.map((data, index) => ({
    id: data.label,
    value: data.value,
    onChange: onChangeDesireStartDate,
    label: data.label,
    checked: _selectDateKubun === data.value,
    isCalendarRadio: index === 1,
    number: 2,
    handleChange: handleChangeDate,
  }));
  const contentDesiredStartTime = {
    title: ADD_CONF_OD_TITLE_TEXT.desiredStartDate,
    label: '必須',
    list: desiredStartDateData,
    type: 'RadioInput',
  };
  // モーダルボタン
  const buttonDesiredStartTime = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveDesiredStartTime,
    valid: true,
  };
  /** * 就業開始時期 モーダル END *** */ 

  /** * 勤務期間 モーダル START *** */
  const changeWorkPeriod = ()=>{
    setSelectWorkPeriod(strWorkPeriod);
    setIsOpenWorkPeriod(true);
  };
  const isCloseWorkPeriod = () => {
    setIsOpenWorkPeriod(false);
  };
  const isSaveWorkPeriod = () => {
    setStrWorkPeriod(_selectWorkPeriod);
    setIsOpenWorkPeriod(false);
  };
  // 勤務期間 選択
  const onChangeWorkPeriod = (e)=>{
    setSelectWorkPeriod(e.target.value);
    if(!isShowError._selectWorkPeriod) {
      setIsShowError({ ...isShowError, _selectWorkPeriod: true });
    }

  };

  // モーダル中身
  const contentWorkPeriod = {
    title: ADD_CONF_OD_TITLE_TEXT.workPeriod,
    label: '必須',
    questionMark: true,
    popUpTitle: COMMENT_MAP.workPeriodCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.workPeriodCmnt.popUpDetail,
    list: [ {
      name: 'strWorkPeriod',
      value: _selectWorkPeriod,
      onChange: (e) => onChangeWorkPeriod(e),
      maxLength: '500',
      rows: '10',
      cols: '100',
      wordCount: '(500文字以下)',
    } ],
    type: 'TextAreaInput',

  };
  // モーダルボタン
  const buttonWorkPeriod = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkPeriod,
    valid: Object.keys(workPeriodValids).every(key => workPeriodValids[key].valid),
  };
  /** * 勤務期間 モーダル END *** */

  /** * 勤務日 モーダル START *** */
  const changeWorkDay = ()=>{
    setSelectDayOfTheWeek(strDayOfTheWeek);
    setIsOpenWorkDay(true);
  };
  const isCloseWorkDay = () => {
    setIsOpenWorkDay(false);
  };
  const isSaveWorkDay = () => {
    setStrDayOfTheWeek(_selectDayOfTheWeek);
    setIsOpenWorkDay(false);
  };
  // 勤務日 選択
  const onChangeWorkDay = (e)=>{
    setSelectDayOfTheWeek(e.target.value);
    if(!isShowError._selectDayOfTheWeek) {
      setIsShowError({ ...isShowError, _selectDayOfTheWeek: true });
    }
  };

  // モーダル中身
  const contentWorkDay = {
    title: ADD_CONF_OD_TITLE_TEXT.workDay,
    label: '必須',
    questionMark: true,
    popUpTitle: COMMENT_MAP.workStyleCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.workStyleCmnt.popUpDetail,
    list: [ {
      name: 'strDayOfTheWeek',
      value: _selectDayOfTheWeek,
      onChange: (e) => onChangeWorkDay(e),
      maxLength: '500',
      rows: '10',
      cols: '100',
      wordCount: '(500文字以下)',
    } ],
    type: 'TextAreaInput',
  };
  // モーダルボタン
  const buttonWorkDay = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkDay,
    valid: Object.keys(dayOfTheWeekValids).every(key => dayOfTheWeekValids[key].valid),
  };
  /** * 勤務日 モーダル END *** */ 

  /** * 勤務時間 モーダル START *** */
  const changeWorkTime = ()=>{
    setModalWorkTime(strWorkTime);
    setIsOpenWorkTime(true);
  };
  const isCloseWorkTime = () => {
    setIsOpenWorkTime(false);
  };
  const isSaveWorkTime = () => {
    setStrWorkTime(_modalWorkTime)
    setIsOpenWorkTime(false);
  };
  const onChangeWorkTime = (e)=>{
    setModalWorkTime(e.target.value);
    if(!isShowError._modalWorkTime) {
      setIsShowError({ ...isShowError, _modalWorkTime: true });
    }
  };

  // モーダル中身
  const contentWorkTime = {
    title: ADD_CONF_OD_TITLE_TEXT.workTime,
    label: '必須',
    questionMark: true,
    popUpTitle: COMMENT_MAP.workTimeCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.workTimeCmnt.popUpDetail,
    list: [ {
      name: 'strWorkTime',
      value: _modalWorkTime,
      onChange: (e) => onChangeWorkTime(e),
      maxLength: '1500',
      rows: '10',
      cols: '100',
      wordCount: '(1500文字以下)',
    } ],
    type: 'TextAreaInput',
  };
  // モーダルボタン
  const buttonWorkTime = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkTime,
    valid: Object.keys(workTimeValids).every(key => workTimeValids[key].valid),
  };
  /** * 勤務時間 モーダル END *** */

  /** * 残業時間 モーダル START *** */
  const changeOverTime = ()=>{
    setIsOpenOverTime(true);
  };
  const isCloseOverTime = () => {
    setIsOpenOverTime(false);
  };
  const isSaveOverTime = () => {
    setOverTime('00');
    setOvertimeHoursMin(_selectOverTimeMin);
    setOvertimeHoursMax(_selectOverTimeMax);
    setIsOpenOverTime(false);
  };
  // 残業時間 選択
  const onChangeOverTimeMin = (value)=>{
    setSelectOverTimeMin(value);
  };

  const onChangeOverTimeMax = (value)=>{
    setSelectOverTimeMax(value);
  };

  // モーダル中身
  const contentOverTime = {
    title: ADD_CONF_OD_TITLE_TEXT.overTime,
    label: '必須',
    list: 
  <div className='ACONF_overTime'>
    <span className='ACONF_overTime_DB'>
      <DropdownInput
        items={overTimeHourList}
        selectedValue={_selectOverTimeMin}
        onChange={onChangeOverTimeMin}
        isOpen={false}
      />
    </span>
    <label>～</label>
    <span className='ACONF_overTime_DB'>
      <DropdownInput
        items={overTimeHourList}
        selectedValue={_selectOverTimeMax}
        onChange={onChangeOverTimeMax}
        isOpen={false}
      />
    </span>
    <label>時間</label>
    <span className='ACONF_ERR'>
      <PcErrorArea position='absolute' message={dispErrors().overTime} />
    </span>
  </div>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonOverTime = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveOverTime,
    valid: overTimeValids.checkOverTimeLessThan0Hour.valid,
  };
  /** * 残業時間 モーダル END *** */

  /** * 請求金額 モーダル START *** */
  const changeSalary = ()=>{
    setIsOpenSalary(true);
  };
  const isCloseSalary = () => {
    setIsOpenSalary(false);
  };
  const isSaveSalary = () => {
    setHourSalaryMin(_modalSalaryMin);
    setHourSalaryMax(_modalSalaryMax);
    setIsOpenSalary(false);
  };
  // 請求金額 選択
  const onChangeHourSalaryMin = (e) =>{
    setModalSalaryMin(e.target.value);
    if(!isShowError._modalSalaryMin) {
      setIsShowError({ ...isShowError, _modalSalaryMin: true });
    }
  };

  const onChangeHourSalaryMax = (e) =>{
    setModalSalaryMax(e.target.value);
    if(!isShowError._modalSalaryMin) {
      setIsShowError({ ...isShowError, _modalSalaryMin: true });
    }
  };

  // モーダル中身
  const contentSalary = {
    title: ADD_CONF_OD_TITLE_TEXT.salary,
    label: '必須',
    list: 
  <span className='ACONF_hourSalary'>
    <TextInput
      name='_modalSalaryMin'
      val={_modalSalaryMin}
      onChange={(e) => onChangeHourSalaryMin(e)}
      onInput={(e) => onChangeHourSalaryMin(e)}
      onCompositionEnd={(e) => onChangeHourSalaryMin(e)}
      maxLength='4'
      placeholder=''
      inValid
    />
    <label> ～ </label>
    <TextInput
      name='_modalSalaryMax'
      val={_modalSalaryMax}
      onChange={(e) => onChangeHourSalaryMax(e)}
      onInput={(e) => onChangeHourSalaryMax(e)}
      onCompositionEnd={(e) => onChangeHourSalaryMax(e)}
      maxLength='4'
      placeholder=''
      inValid
    />
    <label>円/時間</label>
    <span className='ACONF_ERR'>
      <PcErrorArea position='absolute' message={dispErrors()._modalSalaryMin} />
    </span>
  </span>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonSalary = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveSalary,
    valid: Object.keys(hourSalaryValids).every(key => hourSalaryValids[key].valid),
  };
  /** * 請求金額 モーダル END *** */

  /** * 仕事内容 モーダル START *** */
  const changeWorkInfo = ()=>{
    setModalWorkInfo(strWorkInfo);
    setIsOpenWorkInfo(true);
  };
  const isCloseWorkInfo = () => {
    setIsOpenWorkInfo(false);
  };
  const isSaveWorkInfo = () => {
    setStrWorkInfo(_modalWorkInfo);
    setIsOpenWorkInfo(false);
  };
  const onChangeWorkInfo = (e)=>{
    setModalWorkInfo(e.target.value);
    if(!isShowError._modalWorkInfo) {
      setIsShowError({ ...isShowError, _modalWorkInfo: true });
    }
  };

  // モーダル中身
  const contentWorkInfo = {
    title: ADD_CONF_OD_TITLE_TEXT.jobList,
    label: '必須',
    questionMark: true,
    popUpTitle: COMMENT_MAP.workInfoContentCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.workInfoContentCmnt.popUpDetail,
    list: [ {
      name: 'strWorkInfo',
      value: _modalWorkInfo,
      onChange: (e) => onChangeWorkInfo(e),
      maxLength: '1500',
      rows: '10',
      cols: '100',
      wordCount: '(1500文字以下)',
    } ],
    type: 'TextAreaInput',
  };
  // モーダルボタン
  const buttonWorkInfo = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkInfo,
    valid: Object.keys(workInfoValids).every(key => workInfoValids[key].valid),
  };
  /** * 仕事内容 モーダル END *** */ 

  /** * ソフト・ツール モーダル START *** */
  // Excel
  const changeSkillExcel = ()=>{
    setSelectExcel(skillLevelExcel);
    setIsOpenSkillExcel(true);
  };
  const isCloseSkillExcel = () => {
    setIsOpenSkillExcel(false);
  };
  const isNextSkillExcel = () => {
    setSkillLevelExcel(_selectExcel);
    setIsOpenSkillExcel(false);
    changeSkillPowerpoint();
  };
  // ソフト・ツール 選択
  const onChangeSkillExcel = (value)=>{
    setSelectExcel(value);
  };

  // モーダル中身    
  const contentSkillExcel = {
    title: ADD_CONF_OD_TITLE_TEXT.software,
    label: '必須',
    list: [
      <span className='ACONF_skillTitle'>
        Excel
      </span>,
      <span>
        {skillLevelExcelConfList.map(data => (
          <span className="ACONF_skillRadio">
            <RadioInput
              id={data.label}
              value={data.value}
              label={data.label}              
              onChange={() => onChangeSkillExcel(data.value)}
              checked={_selectExcel === data.value}
            />
          </span>
        ))}
      </span>,
    ],
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonSkillExcel = {
    label: '次へ',
    onClick: isNextSkillExcel,
    valid: true,
  };

  // PowerPoint
  const changeSkillPowerpoint = ()=>{
    setSelectPowerpoint(skillLevelPowerpoint);
    setIsOpenSkillPowerpoint(true);
  };
  const isCloseSkillPowerpoint = () => {
    setIsOpenSkillPowerpoint(false);
  };
  const isSaveSkillPowerpoint = () => {
    setSkillLevelPowerpoint(_selectPowerpoint);
    setIsOpenSkillPowerpoint(false);
  };
  // ソフト・ツール 選択
  const onChangeSkillPowerpoint = (value)=>{
    setSelectPowerpoint(value);
  };

  // モーダル中身
  const contentSkillPowerpoint = {
    title: ADD_CONF_OD_TITLE_TEXT.software,
    label: '必須',
    list: [
      <span className='ACONF_skillTitle'>
        PowerPoint
      </span>,
      <span>
        {skillLevelPowerpointConfList.map(data => (
          <span className="ACONF_skillRadio">
            <RadioInput
              id={data.label}
              value={data.value}
              label={data.label}              
              onChange={() => onChangeSkillPowerpoint(data.value)}
              checked={_selectPowerpoint === data.value}
            />
          </span>
        ))}
      </span>,
    ],
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonSkillPowerpoint = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveSkillPowerpoint,
    valid: true,
  };
  /** * ソフト・ツール モーダル END *** */

  /** * その他スキル モーダル START *** */
  const changeOtherSkill = ()=>{
    setMdalOtherSkill(strOtherSkill);
    setIsOpenOtherSkill(true);
  };
  const isCloseOtherSkill = () => {
    setIsOpenOtherSkill(false);
  };
  const isSaveOtherSkill = () => {
    setStrOtherSkill(_modalOtherSkill);
    setIsOpenOtherSkill(false);
  };
  const onChangeOtherSkill = (e)=>{
    setMdalOtherSkill(e.target.value);
    if(!isShowError._modalOtherSkill) {
      setIsShowError({ ...isShowError, _modalOtherSkill: true });
    }
  };
  // モーダル中身
  const contentOtherSkill = {
    title: COMMENT_MAP.skillOtherCmnt.title,
    subTitle: COMMENT_MAP.skillOtherCmnt.subTitle,
    label: '非表示',
    questionMark: true,
    popUpTitle: COMMENT_MAP.skillOtherCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.skillOtherCmnt.popUpDetail,
    list: [ {
      name: 'strOtherSkill',
      value: _modalOtherSkill,
      onChange: (e) => onChangeOtherSkill(e),
      maxLength: '500',
      rows: '10',
      cols: '100',
      wordCount: '(500文字以下)',
    } ],
    type: 'TextAreaInput',
  };
  // モーダルボタン 
  const buttonOtherSkill = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveOtherSkill,
    valid: Object.keys(otherSkillValids).every(key => otherSkillValids[key].valid),
  };
  /** * その他スキル モーダル END *** */

  /** * 職場環境の特徴 モーダル START *** */
  const changeWorkEnvi = ()=>{
    setModalWorkEnvi(strWorkEnvi);
    setIsOpenWorkEnvi(true);
  };
  const isCloseWorkEnvi = () => {
    setIsOpenWorkEnvi(false);
  };
  const isSaveWorkEnvi = () => {
    setStrWorkEnvi(_modalWorkEnvi);
    setIsOpenWorkEnvi(false);
  };
  const onChangeWorkEnvi = (e)=>{
    setModalWorkEnvi(e.target.value);
    if(!isShowError._modalWorkEnvi) {
      setIsShowError({ ...isShowError, _modalWorkEnvi: true });
    }
  };
  // モーダル中身
  const contentWorkEnvi = {
    title: ADD_CONF_OD_TITLE_TEXT.workEnvi,
    list: [ {
      name: 'strWorkEnvi',
      value: _modalWorkEnvi,
      onChange: (e) => onChangeWorkEnvi(e),
      maxLength: '500',
      rows: '10',
      cols: '100',
      wordCount: '(500文字以下)',
    } ],
    type: 'TextAreaInput',
  };
  // モーダルボタン 
  const buttonWorkEnvi = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkEnvi,
    valid: Object.keys(workEnviValids).every(key => workEnviValids[key].valid),
  };
  /** * 職場環境の特徴 モーダル END *** */
  
  /** * 募集背景 モーダル START *** */
  const changeBgdOfRecruitment = ()=>{
    setSelectBgdOfRecruitment(bgdOfRecruitment);
    setSelectBgdOfRecruitmentCmnt(bgdOfRecruitmentCmnt);
    setIsOpenBgdOfRecruitment(true);
  };
  const isCloseBgdOfRecruitment = () => {
    setIsOpenBgdOfRecruitment(false);
  };
  const isSaveBgdOfRecruitment = () => {
    setBgdOfRecruitment(_selectBgdOfRecruitment);
    setBgdOfRecruitmentCmnt(_selectBgdOfRecruitmentCmnt);
    setIsOpenBgdOfRecruitment(false);
  };
  // 募集背景 選択
  const onChangeBgdOfRecruitment = (value)=>{
    setSelectBgdOfRecruitment(value);
    setSelectBgdOfRecruitmentCmnt('');
  };
  // 募集背景 その他入力
  const onChangeBgdOfRecruitmentCmnt = (e) => {
    setSelectBgdOfRecruitmentCmnt(e.target.value);
    if(!isShowError._selectBgdOfRecruitmentCmnt) {
      setIsShowError({ ...isShowError, _selectBgdOfRecruitmentCmnt: true });
    }
  };
  // モーダル中身
  const bgdOfRecruitmentData = bgdOfRecruitmentList.map((data) => ({
    id: `bgdOfRecruitment${ data.value}`,
    value: data.value,
    onChange: () => onChangeBgdOfRecruitment(data.value),
    label: data.label,
    checked: _selectBgdOfRecruitment === data.value,
    number: 2,
  }));
  const contentBgdOfRecruitment = {
    title: ADD_CONF_OD_TITLE_TEXT.bgdOfRecruitment,
    label: '必須',
    list: bgdOfRecruitmentData,
    type: 'RadioInput',
    comment: {
      title: COMMENT_MAP.bgdOfRecruitmentCmnt.title,
      visible: _selectBgdOfRecruitment === COMMENT_MAP.bgdOfRecruitmentCmnt.value,
      label: '非表示',
      questionMark: false,
      popUpTitle: COMMENT_MAP.bgdOfRecruitmentCmnt.popUpTitle,
      popUpDetail: COMMENT_MAP.bgdOfRecruitmentCmnt.popUpDetail,
      relativePosArrow: '25%',
      name: 'bgdOfRecruitmentCmnt',
      textAreaValue: _selectBgdOfRecruitmentCmnt,
      cmntOnChange: onChangeBgdOfRecruitmentCmnt,
      onInput: onChangeBgdOfRecruitmentCmnt,
      onCompositionEnd: onChangeBgdOfRecruitmentCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors()._selectBgdOfRecruitmentCmnt,
    },
  };
  // モーダルボタン
  const buttonBgdOfRecruitment = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveBgdOfRecruitment,
    valid: Object.keys(bgdOfRecruitmentCmntValids).every(key => bgdOfRecruitmentCmntValids[key].valid),
  };
  /** * 募集背景 モーダル END *** */

  /** * テレワーク モーダル START *** */
  const changeRemoteWork = ()=>{
    setSelectRemoteWork(remoteWork);
    setSelectRemoteWorkCount(remoteWorkCount);
    setIsOpenRemoteWork(true);
  };
  const isCloseRemoteWork = () => {
    setIsOpenRemoteWork(false);
  };
  const isSaveRemoteWork = () => {
    setRemoteWork(_selectRemoteWork);
    setRemoteWorkCount(_selectRemoteWorkCount);
    setIsOpenRemoteWork(false);
  };
  // テレワーク 選択
  const onChangeRemoteWork = (value)=>{
    setSelectRemoteWork(value);
    setSelectRemoteWorkCount('');
    if(!isShowError.remoteWorkCount) {
      setIsShowError({ ...isShowError, remoteWorkCount: true });
    }
  };
  const onChangeRemoteWorkCount = (value)=>{
    setSelectRemoteWorkCount(value);
  };

  const remoteWorkData = remoteWorkList.map((data) => ({
    id: `remoteWork${ data.value}`,
    value: data.value,
    onChange: () => onChangeRemoteWork(data.value),
    label: data.label,
    checked: _selectRemoteWork === data.value,
    number: 2,
  }));
  const contentRemoteWork = {
    title: ADD_INPUT_CONF_TITLE.remoteWork,
    label: '必須',
    list: remoteWorkData,
    type: 'RadioChidInput',
    radioChild: _selectRemoteWork.includes("01")?
    {
      title: ADD_INPUT_CONF_TITLE.remoteWorkCount,
      label: '必須',
      list: CHOICES_MAP.remoteWorkCountList.map((elem) => {
        const infoStr = 'remoteWorkCount';
        return {
          value: elem.value,
          label: elem.label,
          id: infoStr + elem.value,
          onChange: () => onChangeRemoteWorkCount(elem.value), // change
          checked: _selectRemoteWorkCount.includes(elem.value),
          name: infoStr,
          number: 3,
        };
      }),
      type: 'RadioInput',
      visible: _selectRemoteWork.includes("01"),
    }
    :null,
  };
  // モーダルボタン
  const buttonRemoteWork = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveRemoteWork,
    valid:  remoteWorkValids.remoteWorkSchema.valid,
  };
  /** * テレワーク モーダル END *** */

  /** * 休日出勤 モーダル START *** */
  const changeHolidayWork = ()=>{
    setSelectHolidayWork(holidayWork);
    setIsOpenHolidayWork(true);
  };
  const isCloseHolidayWork = () => {
    setIsOpenHolidayWork(false);
  };
  const isSaveHolidayWork = () => {
    setHolidayWork(_selectHolidayWork);
    setIsOpenHolidayWork(false);
  };
  // 休日出勤 選択
  const onChangeHolidayWork = (value)=>{
    setSelectHolidayWork(value);
  };
  // モーダル中身
  const holidayWorkData = holidayWorkList.map((data) => ({
    id: `holidayWork${ data.value}`,
    value: data.value,
    onChange: () => onChangeHolidayWork(data.value),
    label: data.label,
    checked: _selectHolidayWork === data.value,
    number: 2,
  }));
  const contentHolidayWork = {
    title: ADD_INPUT_CONF_TITLE.holidayWork,
    label: '必須',
    list: holidayWorkData,
    type: 'RadioInput',
  };
  // モーダルボタン
  const buttonHolidayWork = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveHolidayWork,
    valid: true,
  };
  /** * 休日出勤 モーダル END *** */

  /** * 時短 モーダル START *** */
  const changeTimeSavingAva = ()=>{
    setSelectTimeSavingAva(timeSavingAva);
    setIsOpenTimeSavingAva(true);
  };
  const isCloseTimeSavingAva = () => {
    setIsOpenTimeSavingAva(false);
  };
  const isSaveTimeSavingAva = () => {
    setTimeSavingAva(_selectTimeSavingAva);
    setIsOpenTimeSavingAva(false);
  };
  // 時短 選択
  const onChangeTimeSavingAva = (value)=>{
    setSelectTimeSavingAva(value);
  };
  // モーダル中身
  const timeSavingAvaData = timeSavingAvaList.map((data) => ({
    id: `timeSavingAva${ data.value}`,
    value: data.value,
    onChange: () => onChangeTimeSavingAva(data.value),
    label: data.label,
    checked: _selectTimeSavingAva === data.value,
    number: 2,
  }));
  const contentTimeSavingAva = {
    title: ADD_INPUT_CONF_TITLE.timeSavingAva,
    label: '必須',
    list: timeSavingAvaData,
    type: 'RadioInput',
  };
  // モーダルボタン
  const buttonTimeSavingAva = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveTimeSavingAva,
    valid: true,
  };
  /** * 時短 モーダル END *** */

  /** * 車 モーダル START *** */
  const changeUseCar = ()=>{
    setSelectUseCar(useCar);
    setIsOpenUseCar(true);
  };
  const isCloseUseCar = () => {
    setIsOpenUseCar(false);
  };
  const isSaveUseCar = () => {
    setUseCar(_selectUseCar);
    setIsOpenUseCar(false);
  };
  // 車 選択
  const onChangeUseCar = (value)=>{
    setSelectUseCar(value);
  };
  // モーダル中身
  const useCarData = useCarList.map((data) => ({
    id: `useCar${ data.value}`,
    value: data.value,
    onChange: () => onChangeUseCar(data.value),
    label: data.label,
    checked: _selectUseCar === data.value,
    number: 2,
  }));
  const contentUseCar = {
    title: ADD_INPUT_CONF_TITLE.useCar,
    label: '必須',
    list: useCarData,
    type: 'RadioInput',
  };
  // モーダルボタン
  const buttonUseCar = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveUseCar,
    valid: true,
  };
  /** * 車 モーダル END *** */

  /** * 喫煙 モーダル START *** */
  const changeSmokeEnvi = ()=>{
    setSelectSmokeEnvi(smokeEnvi);
    setIsOpenSmokeEnvi(true);
  };
  const isCloseSmokeEnvi = () => {
    setIsOpenSmokeEnvi(false);
  };
  const isSaveSmokeEnvi = () => {
    setSmokeEnvi(_selectSmokeEnvi);
    setIsOpenSmokeEnvi(false);
  };
  // 喫煙 選択
  const onChangeSmokeEnvi = (value)=>{
    setSelectSmokeEnvi(value);
  };
  // モーダル中身
  const smokeEnviData = smokeEnviList.map((data) => ({
    id: `smokeEnvi${ data.value}`,
    value: data.value,
    onChange: () => onChangeSmokeEnvi(data.value),
    label: data.label,
    checked: _selectSmokeEnvi === data.value,
    number: 2,
  }));
  const contentSmokeEnvi = {
    title: ADD_INPUT_CONF_TITLE.smokeEnvi,
    label: '必須',
    list: smokeEnviData,
    type: 'RadioInput',
  };
  // モーダルボタン
  const buttonSmokeEnvi = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveSmokeEnvi,
    valid: true,
  };
  /** * 喫煙 モーダル END *** */

  /** * 福利厚生 モーダル START *** */
  const changeWelfare = ()=>{
    const clone = [...welfare];
    setSelectWelfare(clone);
    setIsOpenWelfare(true);
  };
  const isCloseWelfare = () => {
    setIsOpenWelfare(false);
  };
  const isSaveWelfare = () => {
    setWelfare(_selectWelfare);
    setIsOpenWelfare(false);
  };
  // 募集背景 選択
  const onChangeWelfare = (value)=>{
    if(value === '09'){
      // 該当なし以外を消す
      if (_selectWelfare.includes(value)) {        
        setSelectWelfare([]);
      } else {
        setSelectWelfare([ '09' ]);
      }
    } else {
      // 該当なしを消す
      if(_selectWelfare.includes('09')){
        setSelectWelfare(_selectWelfare.splice(_selectWelfare.indexOf('09'), 1));
      }
      if (_selectWelfare.includes(value)) {
        setSelectWelfare(_selectWelfare.filter(item => item !== value));
      } else {
        setSelectWelfare([ ..._selectWelfare, value ]);
      }
    }
    if(!isShowError._selectWelfare) {
      setIsShowError({ ...isShowError, _selectWelfare: true });
    }
  };
  // モーダル中身
  const welfareData = welfareList.map((data) => ({
    id: `welfare${ data.value}`,
    value: data.value,
    onChange: () => onChangeWelfare(data.value),
    label: data.label,
    checked: _selectWelfare.includes(data.value),
  }));
  const contentWelfare = {
    title: ADD_INPUT_CONF_TITLE.welfare,
    label: '必須',
    list: welfareData,
    type: 'BasicCheckBoxInput',
    // number: 3,
  };
  // モーダルボタン
  const buttonWelfare = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWelfare,
    valid: Object.keys(welfareValids).every(key => welfareValids[key].valid),
  };
  /** * 福利厚生 モーダル END *** */

  /** * CONFIRM モーダル START *** */
  const openConfirm = ()=>{
    setIsOpenConfirm(true);
  };
  const closeConfirm = () => {
    setIsOpenConfirm(false);
  };
  // モーダル中身
  const confirmModal = {
    modalIsOpen: isOpenConfirm,
    nextButton: {
      label: 'はい',
      link: ADD_INPUT_URL,
      onClick: (e)=>resetState(e),
    },
    cancelButton: {
      label: 'いいえ',
      onClick: (e)=>closeConfirm(e),
      valid: true,
    },
    onClickCloseButton: closeConfirm,
  };
  /** * CONFIRM モーダル END *** */ 

  // onChange 連絡事項 && チェックリスト項目
  
  const onChangeOtherComment = (e) =>{
    setOtherComment(e.target.value);
    if(!isShowError.otherComment) {
      setIsShowError({ ...isShowError, otherComment: true });
    }
  };

  // 画面項目
  const getDate = () => {
    switch(desiredStartDateKubun){
      case '': return NOT_FILL;
        break;
      case '01': return '即日開始';
        break;
      case '02': return `${String(desiredStartDate).split('/')[0]}年${String(desiredStartDate).split('/')[1]}月${String(desiredStartDate).split('/')[2]}日`;
        break;
      default: break;
    }
  };

  useEffect(()=>{
    
    if(workPeriod== '03'||workPeriod== '02'){
      const str = getChoiceValues('workPeriodList')
        .filter(d => workPeriod.includes(d))
        .map(d => getChoiceLabel('workPeriodList', d))
        .join(' ');
      setStrWorkPeriod(str);
    }
    if (workPeriod== '01') {
      setStrWorkPeriod(workPeriodCmnt);
    }
  }
  , [ workPeriod ]);

  const getBgdOfRecruitment = () => {
    if(bgdOfRecruitment === ''){
      return (
        NOT_FILL
      );
    } 
    const target = bgdOfRecruitmentList.find(v=>v.value === bgdOfRecruitment);
    return <label>{bgdOfRecruitment === COMMENT_MAP.bgdOfRecruitmentCmnt.value? bgdOfRecruitmentCmnt : target.label}</label>;
  };

  useEffect(()=>{

    if(workStyle === '01'){
      const str = getChoiceValues('dayOfTheWeekList')
        .filter(d => ['1', '2', '3', '4', '5'].includes(d))
        .map(d => getChoiceLabel('dayOfTheWeekList', d))
        .join(' ');
      setStrDayOfTheWeek(str);
    }
    if(workStyle === '02'){
      setStrDayOfTheWeek(workStyleCmnt);
    }

  }, [ workStyle ]);

  useEffect(()=>{
    let str = '(始業時間)';
    const getWorkTime = ()=>{
      if(!(startTime === '' || startTime === '05')) {
        const startTimeLabel = getChoiceLabel('startTimeList', startTime);
        str += `\n・${startTimeLabel}`;
      }else if(startTime === '05'){
        str += `\n・${startTimeCmnt}`;
      }
      str += '\n\n(終業時間)';
      if(!(endTime === '' || endTime === '05')) {
        const endTimeLabel = getChoiceLabel('endTimeList', endTime);
        str += `\n・${endTimeLabel}`;
      }else if(endTime === '05'){
        str += `\n・${endTimeCmnt}`;
      }
      str += '\n\n(うち休憩時間)';
      str += `\n・60分`;
      setStrWorkTime(str);

    };
    getWorkTime();
  }, [ endTime, startTime ]);

  useEffect(()=> {
    const getOverTime = () => {
      switch(overTime){
        // 残業なし
        case '01':
          setOvertimeHoursMin('0');
          setOvertimeHoursMax('0');
          break;
          // 20時間/月 未満
        case '02':
          setOvertimeHoursMin('1');
          setOvertimeHoursMax('20');
          break;
          // 20時間/月 以上
        case '03':
          setOvertimeHoursMin('21');
          setOvertimeHoursMax('40');
          break;
        default: break;
      }
    };
    getOverTime();
  }, [ overTime ]);
  useEffect(()=>{
    const setStateOverTime = ()=>{
      setSelectOverTimeMin(overtimeHoursMin);
      setSelectOverTimeMax(overtimeHoursMax);
    };
    setStateOverTime();
  }, [ overtimeHoursMin, overtimeHoursMax ]);

  const getJD = () => {
    if(strWorkInfo === ''){
      return (
        NOT_FILL
      );
    }
    return(
      <label>{strWorkInfo}</label>
    );
  };
  useEffect(()=>{
    if(workInfoContent.length === 0){ 
      setStrWorkInfo('');
    } else {
      let str = '(業務内容)';
      let workInfoContentTmp = workInfoContent.filter(item => item !== COMMENT_MAP.workInfoContentCmnt.value);
      let strContent = getChoiceValues('workInfoContentList')
        .filter(w => workInfoContentTmp.includes(w))
        .map(w => getChoiceLabel('workInfoContentList', w))
        .join('\n・');
      if (workInfoContentTmp && workInfoContentTmp.length > 0) {
        strContent = `\n・${strContent}`;
        str += strContent;
      }
      if (workInfoContent.includes(COMMENT_MAP.workInfoContentCmnt.value)) {
        str += '\n\n(その他)';
        str += `\n・${workInfoContentCmnt}`;
      }
      setStrWorkInfo(str);
    }
  }, [ workInfoContent ]);

  const getSkillLevel = () => {
    if(skillLevel === ''){
      return (
        NOT_FILL
      );
    }
    setSkillLevelExcel(skillLevel);
    setSkillLevelPowerpoint(skillLevel);
  };

  const getSkill = () => {
    if(skillLevelExcel === '' || skillLevelPowerpoint === ''){
      getSkillLevel();
    } else {
      const ex = skillLevelExcelConfList.find(v=>v.value === skillLevelExcel);
      const pp = skillLevelPowerpointConfList.find(v=>v.value === skillLevelPowerpoint);
    
      return (
        <span className=''>
          <p>
            Excel
            {' '}
            {ex.label}
            {' '}
          </p>
          <p>
            Powerpoint
            {' '}
            {pp.label}
            {' '}
          </p>
        </span>
      );
    }
  };

  useEffect(()=>{
    if(workEnvi.length !== 0){
      const str = getChoiceValues('workEnviList')
        .filter(w => workEnvi.includes(w))
        .map(w => getChoiceLabel('workEnviList', w))
        .join(' / ');
      setStrWorkEnvi(str);
    }
  }, [ workEnvi ]);

  useEffect(()=>{
    setModalSalaryMin(hourSalaryMin);
    setModalSalaryMax(hourSalaryMax);
  }, [ hourSalaryMin, hourSalaryMax ]);

  const getUseCar = () => {
    const target = useCarList.find(v => v.value === useCar);
    return <label>{target.label}</label>;
  };

  const getHolidayWork = () => {
    const target = holidayWorkList.find(v => v.value === holidayWork);
    return <label>{target.label}</label>;
  };

  const getRemoteWork = () => {
    if (remoteWork === '01') {
      const target = remoteWorkCountList.find(v => v.value === remoteWorkCount);
      return <label>{target.label}</label>;
    } else {
      const target = remoteWorkList.find(v => v.value === remoteWork);
      return <label>{target.label}</label>;
    }
  };

  const getWelfare = () => {
    const str = getChoiceValues('welfareList')
      .filter(w => welfare.includes(w))
      .map(w => getChoiceLabel('welfareList', w))
      .join(' / ');
    return <label>{str}</label>;
  };

  const getSmokeEnvi = () => {
    const target = smokeEnviList.find(v => v.value === smokeEnvi);
    return <label>{target.label}</label>;
  };

  const getTimeSavingAva = () => {
    const target = timeSavingAvaList.find(v => v.value === timeSavingAva);
    return <label>{target.label}</label>;
  };

  // 画面項目メソッド呼び出し
  const showDate = getDate();
  const showJD = getJD();
  const showSkill = getSkill();

  // 勤務条件リスト
  const workDetailList = [
    // 仕事内容
    {
      text: ADD_CONF_OD_TITLE_TEXT.jobList, 
      children: showJD,
      modifyLinks: changeWorkInfo,
    },

    // ソフト・ツール
    {
      text: ADD_CONF_OD_TITLE_TEXT.software,
      children: showSkill,
      modifyLinks: changeSkillExcel, 
    },
    // 請求金額
    {
      text: ADD_CONF_OD_TITLE_TEXT.salary,
      children: 
  <span className=''>
    {hourSalaryMin === '' ? NOT_FILL : hourSalaryMin}
    {' '}
    ～
    {' '}
    {hourSalaryMax === '' ? NOT_FILL : hourSalaryMax}
    {' '}
    円/時間
  </span>,
      modifyLinks: changeSalary,
    },
    // その他スキル
    {
      text: ADD_CONF_OD_TITLE_TEXT.otherSkill,
      children:
        <span>
           {strOtherSkill === '' ? NOT_FILL : <label>{strOtherSkill}</label>}
        </span>,
      modifyLinks: changeOtherSkill, 
    },

    // 勤務形態
    // 勤務日
    {
      text: ADD_CONF_OD_TITLE_TEXT.workDay,
      children: <label>{strDayOfTheWeek}</label>,
      modifyLinks: changeWorkDay,
    },
    // テレワーク
    {
      text: ADD_CONF_OD_TITLE_TEXT.remoteWork, 
      children: getRemoteWork(),
      modifyLinks: changeRemoteWork,
    },
    // 休日出勤
    {
      text: ADD_CONF_OD_TITLE_TEXT.holidayWork, 
      children: getHolidayWork(),
      modifyLinks: changeHolidayWork,
    },
    // 勤務時間
    {
      text: ADD_CONF_OD_TITLE_TEXT.workTime,
      children: 
  <div> 
    <label>{strWorkTime}</label>
  </div>,
      modifyLinks: changeWorkTime,
    },
    // 残業時間
    {
      text: ADD_CONF_OD_TITLE_TEXT.overTime,
      children: 
  <span className=''> 
    {' '}
    {overtimeHoursMin === '' ? NOT_FILL : <label>{overtimeHoursMin}</label>}
    {' '}
    ～
    {' '}
    {overtimeHoursMax === '' ? NOT_FILL : <label>{overtimeHoursMax}</label>}
    {' '}
    時間
  </span>,
      modifyLinks: changeOverTime,
    },
    // 時短
    {
      text: ADD_CONF_OD_TITLE_TEXT.timeSavingAva, 
      children: getTimeSavingAva(),
      modifyLinks: changeTimeSavingAva,
    },
    // 就業開始時期
    {
      text: ADD_CONF_OD_TITLE_TEXT.desiredStartDate,
      children: showDate,
      modifyLinks: changeDesiredStartTime,
    },
    // 勤務期間
    {
      text: ADD_CONF_OD_TITLE_TEXT.workPeriod,
      children: <label>{strWorkPeriod}</label>,
      modifyLinks: changeWorkPeriod,
    },
  ];

  // 職務情報リスト
  const jobInfoList = [
    // 職場環境の特徴
    {
      text: ADD_CONF_OD_TITLE_TEXT.workEnvi,
      children: 
  <span>
    {strWorkEnvi === '' ? NOT_FILL : <label>{strWorkEnvi}</label>}
  </span>,
      modifyLinks: changeWorkEnvi,
    },
    // 募集背景
    {
      text: ADD_CONF_OD_TITLE_TEXT.bgdOfRecruitment,
      children: getBgdOfRecruitment(),
      modifyLinks: changeBgdOfRecruitment,
    },
    // 車
    {
      text: ADD_CONF_OD_TITLE_TEXT.useCar, 
      children: getUseCar(),
      modifyLinks: changeUseCar,
    },
    // 喫煙
    {
      text: ADD_CONF_OD_TITLE_TEXT.smokeEnvi, 
      children: getSmokeEnvi(),
      modifyLinks: changeSmokeEnvi,
    },
    // 福利厚生
    {
      text: ADD_CONF_OD_TITLE_TEXT.welfare, 
      children: getWelfare(),
      modifyLinks: changeWelfare,
    },
  ];

  // 職務情報リスト
  const confTitleList = [
    // 勤務条件コンポーネント
    {
      text: ADD_CONF_OD_TITLE_TEXT.workDetail,
      list: workDetailList,
      icon: 'icon_kinmukeitai',
      comment: '',
    },
    // 職場情報コンポーネント
    {
      text: ADD_CONF_OD_TITLE_TEXT.jobInfo,
      list: jobInfoList,
      icon: 'icon_syokumunaiyou',
      comment: '',
    },
  ];

  const modalList = [
    // 就業開始時期
    {
      modalIsOpen: isOpenDesiredStartTime,
      content: contentDesiredStartTime,
      button: buttonDesiredStartTime,
      onClickCloseButton: isCloseDesiredStartTime,
    },
    // 勤務期間
    {
      modalIsOpen: isOpenWorkPeriod,
      content: contentWorkPeriod,
      errorDispMessages: dispErrors()._selectWorkPeriod,
      button: buttonWorkPeriod,
      onClickCloseButton: isCloseWorkPeriod,
    },
    // 勤務日
    {
      modalIsOpen: isOpenWorkDay,
      errorDispMessages: dispErrors()._selectDayOfTheWeek,
      content: contentWorkDay,
      button: buttonWorkDay,
      onClickCloseButton: isCloseWorkDay,
    },
    // 勤務時間
    {
      modalIsOpen: isOpenWorkTime,
      errorDispMessages: dispErrors()._modalWorkTime,
      content: contentWorkTime,
      button: buttonWorkTime,
      onClickCloseButton: isCloseWorkTime,
    },
    // 残業時間
    {
      modalIsOpen: isOpenOverTime,
      content: contentOverTime,
      button: buttonOverTime,
      onClickCloseButton: isCloseOverTime,
    },
    // 請求金額
    {
      modalIsOpen: isOpenSalary,
      content: contentSalary,
      button: buttonSalary,
      onClickCloseButton: isCloseSalary,
    },
    // 仕事内容
    {
      modalIsOpen: isOpenWorkInfo,
      errorDispMessages: dispErrors()._modalWorkInfo,
      content: contentWorkInfo,
      button: buttonWorkInfo,
      onClickCloseButton: isCloseWorkInfo,
    },
    // ソフト・ツール
    {
      modalIsOpen: isOpenSkillExcel,
      content: contentSkillExcel,
      button: buttonSkillExcel,
      onClickCloseButton: isCloseSkillExcel,
    },
    {
      modalIsOpen: isOpenSkillPowerpoint,
      content: contentSkillPowerpoint,
      button: buttonSkillPowerpoint,
      onClickCloseButton: isCloseSkillPowerpoint,
    },
    // その他スキル
    {
      modalIsOpen: isOpenOtherSkill,
      errorDispMessages: dispErrors()._modalOtherSkill,
      content: contentOtherSkill,
      button: buttonOtherSkill,
      onClickCloseButton: isCloseOtherSkill,
    },
    // // 職場環境の特徴
    {
      modalIsOpen: isOpenWorkEnvi,
      errorDispMessages: dispErrors()._modalWorkEnvi,
      content: contentWorkEnvi,
      button: buttonWorkEnvi,
      onClickCloseButton: isCloseWorkEnvi,
    },
    // 募集背景
    {
      modalIsOpen: isOpenBgdOfRecruitment,
      content: contentBgdOfRecruitment,
      button: buttonBgdOfRecruitment,
      onClickCloseButton: isCloseBgdOfRecruitment,
    },
    // テレワーク
    {
      modalIsOpen: isOpenRemoteWork,
      errorDispMessages: dispErrors().remoteWorkCount,
      content: contentRemoteWork,
      button: buttonRemoteWork,
      onClickCloseButton: isCloseRemoteWork,
    },
    // 休日出勤
    {
      modalIsOpen: isOpenHolidayWork,
      content: contentHolidayWork,
      button: buttonHolidayWork,
      onClickCloseButton: isCloseHolidayWork,
    },
    // 時短
    {
      modalIsOpen: isOpenTimeSavingAva,
      content: contentTimeSavingAva,
      button: buttonTimeSavingAva,
      onClickCloseButton: isCloseTimeSavingAva,
    },
    // 車
    {
      modalIsOpen: isOpenUseCar,
      content: contentUseCar,
      button: buttonUseCar,
      onClickCloseButton: isCloseUseCar,
    },
    // 喫煙
    {
      modalIsOpen: isOpenSmokeEnvi,
      content: contentSmokeEnvi,
      button: buttonSmokeEnvi,
      onClickCloseButton: isCloseSmokeEnvi,
    },
    // 福利厚生
    {
      modalIsOpen: isOpenWelfare,
      errorDispMessages: dispErrors()._selectWelfare,
      content: contentWelfare,
      button: buttonWelfare,
      onClickCloseButton: isCloseWelfare,
    },
  ];

  // ボタン押下
  // state更新処理  
  const resetState = () => {
    dispatch({
      type: RESET_ADD_CONF,
    });
    scrollTop();
  };

  const updState = () =>{
    dispatch({
      type: UPDATE_ADD_CONF,
      updAddConf: {
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        timeSavingAva,
        overtimeHoursMin,
        overtimeHoursMax,
        hourSalaryMin,
        hourSalaryMax,
        strWorkInfo,
        skillLevelExcel,
        skillLevelPowerpoint,
        strWorkEnvi,
        strOtherSkill,
        strWorkTime,
        strWorkPeriod,
        strDayOfTheWeek,
        remoteWork,
        remoteWorkCount,
        holidayWork,
        useCar,
        smokeEnvi,
        welfare,
        otherComment,
      },
    });
  };

  const onClickMainButton = {
    prev: () => {
      openConfirm();
    },
    next: (e) => {
      // イベント計測
      MeasureEvent(
        {
          linkTrackVars: MEASURE_MAP.EVENT_85.linkTrackVars,
          linkTrackEvents: MEASURE_MAP.EVENT_85.linkTrackEvents,
          events: MEASURE_MAP.EVENT_85.events,
        },
        MEASURE_MAP.EVENT_85.name,
      );
      scrollTop();
      updState();
      setShowLoding(true);

      const params = {
        desiredStartDateKubun,
        desiredStartDate,
        timeSavingAva,
        overtimeHoursMin: Number(overtimeHoursMin),
        overtimeHoursMax: Number(overtimeHoursMax),
        hourSalaryMin: Number(hourSalaryMin),
        hourSalaryMax: Number(hourSalaryMax),
        strWorkInfo,
        skillLevelExcel,
        skillLevelPowerpoint,
        workEnvi: strWorkEnvi,
        strOtherSkill,
        strWorkPeriod,
        strDayOfTheWeek,
        strWorkTime,
        bgdOfRecruitment,
        bgdOfRecruitmentCmnt,
        otherComment,
        checkPointUseCar: useCar,
        checkPointHolidayWork: holidayWork,
        checkPointRemoteWork: remoteWork,
        checkPointRemoteWorkCount: remoteWorkCount,
        checkPointSmokeEnvi: smokeEnvi,
        checkPointWelfare: welfare,
        companyNameText,
        email,
        receiptID,
        olodTarget,
        clickID,
        mediaID,
      };

      // データ登録処理
      e.preventDefault();
      // 二重登録
      if(isAddRegistered) {
        setIsApiError(true);
        return false;
      };
      // Postパラメータチェック
      const [ isPostValid ] = isSchemaValid({ path: `${path}:post`, target: params });
      if(!isPostValid){
        setIsApiError(true);
        return false;
      };
      // ok
      dispatch({
        type: CHANGE_VALID,
        path,
        valid: isPostValid,
      });

      // 更新処理
      postRegisterOrderApi({ params })
        .then(() => {
          history.push(ADD_THANKS_URL);
        })
        .catch(err => {
          // FATELエラーチェック
          const isFatal = isFatalApiError(err);
          setIsApiError(isFatal);
          if(isFatal) throw err;

          // 400エラーは基本的に起きないためFATAL
          if(err.response.status === 400) {
            setIsApiError(true);
            return false;
          };
          return false;
        });
      return true;
    },
  };

  // 画面表示
  return isSp ? (
    <PresentSP
      otherComment={otherComment}

      onChangeOtherComment={onChangeOtherComment}

      // 画面項目
      confTitleList={confTitleList}

      // モーダル
      modalList={modalList}

      // Confirmモーダル
      confirmModal={confirmModal}

      // onClick
      onClickMainButton={onClickMainButton}

      errorDispMap={dispErrors()}
      isApiError={isApiError}
      showLoading={showLoading}
      valid={valid}

      // カレンダー表示用選択済日付
      selectedDate={
        desiredStartDate ? new Date(desiredStartDate) : desiredStartDate
      }
    />
  ) : (
    <PresentPC
      otherComment={otherComment}

      onChangeOtherComment={onChangeOtherComment}

      // 画面項目
      confTitleList={confTitleList}

      // モーダル
      modalList={modalList}

      // Confirmモーダル
      confirmModal={confirmModal}

      // onClick
      onClickMainButton={onClickMainButton}

      errorDispMap={dispErrors()}
      isApiError={isApiError}
      showLoading={showLoading}
      valid={valid}

      // カレンダー表示用選択済日付
      selectedDate={
        desiredStartDate ? new Date(desiredStartDate) : desiredStartDate
      }
    />
  );
};

export default AddConf;